import type {
    WidgetContext,
    WidgetItem,
    WidgetTemplate,
} from '@experiences/interfaces';

export interface IServiceCardData {
    service: string;
    url: string;
    header: string;
    icon: string;
    description: string;
}

export const ServicesWidget: WidgetTemplate<IServiceCardData> = {
    name: 'Services',
    titleKey: '',
    emptyMsgKey: (_ctx: WidgetContext) => '',
    clickHandler: (data: IServiceCardData, ctx: WidgetContext) => {
        const url = data.url
            .replace('{organization}', ctx.accountLogicalName)
            .replace('{tenant}', ctx.tenant);
        window.open(url, '_self');
    },
    fetch: (_ctx: WidgetContext): Promise<IServiceCardData[]> => new Promise((resolve, reject) => {
        const maxRetries = 10;
        let retryCount = 0;

        const attemptGetServices = () => {
            const tenant = window.PortalShell?.AccountAndTenants?.getTenant();
            if (!tenant) {
                if (retryCount >= maxRetries) {
                    reject(new Error('Unable to fetch tenant.'));
                    return;
                }
                retryCount++;
                setTimeout(attemptGetServices, 250);
                return;
            }

            // Check services are enabled for the tenant
            const services = [
                {
                    service: 'studio',
                    url: `${window.location.origin}/{organization}/studio_`,
                    header: 'Studio',
                    icon: 'studio',
                    description: 'CLIENT_SERVICE_CARD_DESCRIPTION_STUDIO',
                },
                {
                    service: 'agents',
                    url: `${window.location.origin}/{organization}/agents_`,
                    header: 'Agents',
                    icon: 'agents',
                    description: 'CLIENT_SERVICE_CARD_DESCRIPTION_AGENTS',
                },
                {
                    service: 'maestro',
                    url: `${window.location.origin}/{organization}/{tenant}/maestro_`,
                    header: 'Maestro',
                    icon: 'maestro',
                    description: 'CLIENT_SERVICE_CARD_DESCRIPTION_MAESTRO',
                },
                {
                    service: 'orchestrator',
                    url: `${window.location.origin}/{organization}/{tenant}/orchestrator_`,
                    header: 'Orchestrator',
                    icon: 'orchestrator',
                    description: 'CLIENT_SERVICE_CARD_DESCRIPTION_ORCHESTRATOR',
                },
            ];
            const supportedServices = services.filter((service) => tenant.enabledServices.includes(service.service));
            resolve(supportedServices);
        };

        attemptGetServices();
    }),
    type: 'Service',
    transform: (data: IServiceCardData[]): Array<WidgetItem<IServiceCardData>> =>
        data.map((item) => ({
            data: item,
            clickable: true,
            header: item.header,
            icon: item.icon,
            description: item.description,
        })),
};
